const sendToGTM = (eventData) => {
	if ('event' in eventData) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(eventData);
	}
};

export const trackAnalyticsVotedEvent = (selection) => {
	sendToGTM({
		event: 'blogFeedbackVoted',
		blogFeedbackScore: selection,
	});
};
